"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Invoice"] = "invoice";
    PaymentMethod["ValueVoucher"] = "valueVoucher";
    PaymentMethod["StripeCreditCard"] = "stripeCreditCard";
    PaymentMethod["PayPal"] = "paypal";
    PaymentMethod["AmazonPay"] = "amazonPay";
    PaymentMethod["Sofort"] = "sofort";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
//# sourceMappingURL=PaymentMethod.js.map